<template>
  <div class="app-carte" v-if="client">
    <div v-if="client.position">
      <gmap-map
        :center="client.position"
        :zoom="10"
        :options="mapOptions"
        @tilesloaded="initPoi"
        ref="mapRef" class="carte">
        <gmap-marker
          key="test"
          :position="client.position"
          :clickable="false"
          :draggable="false"
          :icon=puceNoire>
        </gmap-marker>
      </gmap-map>
    </div>
    <div class="box historique" v-else>
      <div class="columns">
        <div class="column">
          <p class="title has-text-black is-5"><span class="has-text-weight-semibold">Carte :</span>
            <span class="has-text-weight-normal">Aucune coordonnées GPS renseignées</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { MARKER_POINT_NOIR, STYLE_MAPS_POI_HIDDEN, MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';

const Client = createNamespacedHelpers('client');

export default {
  name: 'carte',
  data() {
    return {
      puceNoire: MARKER_POINT_NOIR,
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  computed: {
    ...Client.mapGetters({
      client: 'client',
    }),
  },
  methods: {
    async initPoi() {
      const map = await this.$refs.mapRef.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
  },
};
</script>

<style scoped>
  .carte {
    width: 40vw;
    height: 40vh;
  }
  .app-carte {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/information/carte.vue